import isEmpty from 'lodash/isEmpty';
import { Option, Value } from './types';

const containsOrIs = (haystack: Value, needle: Option['value']) =>
  (Array.isArray(haystack) && haystack.includes(needle)) || haystack === needle;

export const isChecked = (value: Value, option: Option) =>
  containsOrIs(value, option.value) || (!!option.deselector && isEmpty(value));
